import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=a18e9fe4&scoped=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=a18e9fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18e9fe4",
  null
  
)

export default component.exports